<template>
  <v-app id="app" >
    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  data: () => ({
    //
  }),
};
</script>
<style>
*{
  font-family:-apple-system, 'HelveticaNeue', 'Helvetica Neue', 'Roboto', 'Droid Sans', Arial, 'SHPBurmese', sans-seri
}
.text-white{
  color:white !important;
}
.cursor-pointer{
  cursor: pointer !important;
}
@keyframes pulseShadow {
  0% {
    box-shadow: 0 0 20px #EF9A9A, 0 0 30px #EF9A9A;
  }
  50% {
    box-shadow: 0 0 20px #f9e3e3, 0 0 30px #fde3e3;
  }
  100% {
    box-shadow: 0 0 20px #EF9A9A, 0 0 30px #EF9A9A;
  }
}

.high-light {
  animation: pulseShadow 1.5s infinite ease-in-out;
}

.sw-white-text-button {
  color: white !important;
}
.primary{
  background-color:#2b81d6;
}


.white-text-field > .v-input__control {
  color: white !important;
  border-color: white;
}
.white-text-field > .v-field {
  border-color: white !important;
}

</style>